<template>
	<div class="container text-center my-3 h-100">
		<div class="d-flex flex-column justify-content-center align-items-center h-100">

			<h1 class="title-primary text-dark mb-4">Страница не найдена</h1>
			<p class="text-muted">error code: 404</p>

		</div>
	</div>
</template>